import React from "react";
import { motion } from "framer-motion";

const Joke = () => {
  return (
    <motion.div
      className="joke__qoute"
      whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="joke__qoute-container1">
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.7 }}
          className="joke__qoute-content"
        >
          <p>
            Programming: the art of transforming thoughts into digital
            innovation.
          </p>
        </motion.div>
      </div>
      <div className="joke__qoute-container2">
        <motion.div
          whileInView={{ x: [100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.7 }}
          className="joke__qoute-content"
        >
          <p>Dream in code; build the future.</p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Joke;
